<a [href]="store().url"
   class="wrapper"
   target="_blank">
  <div class="heading inter large w500 meta">{{ store().name }}</div>
  <div class="pic-wrapper">
    <img [alt]="store().name" [ngSrc]="store().logo" fill />
  </div>
</a>
